import { useState, useEffect } from "react";
import axios from "axios";

export const useLoadDistribution = () => {
  const [data, setData] = useState(null);
  const fetchData = async () => {
    try {
      const username = localStorage.getItem("username");
      // or from context: const { username } = useAuth();
      if (!username) return null;

      // Use CRA proxy (configured in package.json) to avoid CORS issues
      const res = await axios.get(`/api/loadDistributionLive?username=${username}`);
      setData(res.data);
      return res.data;
    } catch (err) {
      console.error("Failed to fetch LoadDistribution:", err);
      return null;
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  return { data, fetchData };
};

